export default "__VITE_ASSET__B_xF9e$w__"